var _path, _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnTenx = function SvgIcnTenx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.312 13-4.065-2.174h-.464l-4.098 2.166v-2.37L7.96 8.07l-.003-2.232h-.254L5.83 6.8 3.685 5.582V3L7.783 5.41h.464L12.307 3l.001 2.577-4.31 2.573.004 2.232h.254l1.872-.961 2.183 1.239.001 2.34Z",
    fill: "url(#icn_tenx_svg__a)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_tenx_svg__a",
    x1: 3.599,
    y1: 3.73,
    x2: 13.138,
    y2: 10.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF272B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#FF7B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFA32"
  }))));
};
export default SvgIcnTenx;